/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Sub_Processors_IntroInputs */

const en_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In accordance with GDPR Article 13, we disclose the following sub-processors that process personal data on our behalf:`)
};

const de_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß DSGVO Art. 13 geben wir die folgenden Auftragsverarbeiter bekannt, die personenbezogene Daten in unserem Auftrag verarbeiten:`)
};

const fr_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformément à l'article 13 du RGPD, nous divulguons les sous-traitants suivants qui traitent des données personnelles en notre nom :`)
};

const es_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De conformidad con el artículo 13 del RGPD, divulgamos los siguientes subencargados que procesan datos personales en nuestro nombre:`)
};

const it_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In conformità con l'articolo 13 del GDPR, comunichiamo i seguenti sub-responsabili del trattamento che trattano dati personali per nostro conto:`)
};

const nl_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In overeenstemming met artikel 13 van de AVG maken wij de volgende subverwerkers bekend die persoonlijke gegevens namens ons verwerken:`)
};

const pl_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodnie z art. 13 RODO ujawniamy następujących podwykonawców przetwarzania, którzy przetwarzają dane osobowe w naszym imieniu:`)
};

const fi_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR:n artikla 13 mukaisesti ilmoitamme seuraavat alikäsittelijät, jotka käsittelevät henkilötietoja puolestamme:`)
};

const da_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I overensstemmelse med GDPR artikel 13 oplyser vi følgende underdatabehandlere, der behandler persondata på vores vegne:`)
};

const sv_privacy_sub_processors_intro = /** @type {(inputs: Privacy_Sub_Processors_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I enlighet med GDPR artikel 13 redovisar vi följande underbiträden som behandlar personuppgifter för vår räkning:`)
};

/**
* | output |
* | --- |
* | "In accordance with GDPR Article 13, we disclose the following sub-processors that process personal data on our behalf:" |
*
* @param {Privacy_Sub_Processors_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_sub_processors_intro = /** @type {((inputs?: Privacy_Sub_Processors_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Sub_Processors_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_sub_processors_intro(inputs)
	if (locale === "fr") return fr_privacy_sub_processors_intro(inputs)
	if (locale === "es") return es_privacy_sub_processors_intro(inputs)
	if (locale === "it") return it_privacy_sub_processors_intro(inputs)
	if (locale === "nl") return nl_privacy_sub_processors_intro(inputs)
	if (locale === "pl") return pl_privacy_sub_processors_intro(inputs)
	if (locale === "fi") return fi_privacy_sub_processors_intro(inputs)
	if (locale === "da") return da_privacy_sub_processors_intro(inputs)
	if (locale === "sv") return sv_privacy_sub_processors_intro(inputs)
	return en_privacy_sub_processors_intro(inputs)
});